export default __webpack_public_path__ + "static/9-1d19acafe518644dbb152a3ee2edcb4c.jpg";